// ** Initial State
const initialState = {
  // exhibitor: [],
  // complementry: [],
  agenda: [],
  eventTimingData:[],
  eventProgramData:[],
  categories:[],
  speakersListWithPagination: {
    "limit": 30,
    "page": 0,
    "total_pages": null,
    "total_records": null,
    "data": null
  },
  pageLoader:true,
  favoriteslist:[],
  data: [],
  current_event:[],
  // updateInvite: null,
  // bulkEmail: [],
  // eventsListData: null,
  // eventListWithPagintion: {
  //   limit: 30,
  //   page: 0,
  //   total_pages: null,
  //   total_records: null,
  //   data: null,
  // },
  // pageLoader: true,
};

const agendalist = (state = initialState, action) => {
  switch (action.type) {
    case "GET_AGENDA":
      return { ...state, agenda: action.data };
    case "ADD_EVENT_TIMING":
      return { ...state, eventTimingData: action.data };
    case "ADD_EVENT_PROGRAM":
      return { ...state, eventProgramData: action.data };      
    case "SEND_EDIT_EVENT_PROGRAM":
      return { ...state, editProgramData: action.data };
    case "GET_CATEGORIES_LIST":
      return { ...state, categories: action.data };
    case "GET_TIMINGS_DATA_BASED_EVENT_DATE_ID":
      return { ...state, allEventTimings: action.data };
    case "GET_ALL_SPEAKERS_WITH_PAGINATION":
      return { ...state, speakersListWithPagination : action.data, pageLoader: false };
    case "EVENT_FAVORITES_LIST":
      return { ...state, favoriteslist : action.data};
    case "DELETE_EVENT_PROGRAM":
      return { ...state, data: action.data };
    case "DELETE_EVENT_TIMING":
      return { ...state, data: action.data };
    case "CURRENT_EVENT_AGENDA":
      // console.log('fgdfg',action.data);
      return { ...state, current_event: action.data };
    // case "GET_DATA":
    //   return { ...state, data: action.data };
    // case "SET_DATA":
    //   return { ...state, data: action.data };
    // // case 'COMPLEMENT_CREATION':
    // //   return { ...state, complementry: action.data }
    // case "DELETE_DATA":
    //   return { ...state, data: action.data };
    // case "UPDATE_INVITE":
    //   return { ...state, updateInvite: action.data };
    // case "SET_BULK_EMAIL":
    //   return { ...state, bulkEmail: action.data };
    // case "GET_ALL_INVITATION_WITH_PAGINATION":
    //   return { ...state, invitationListWithPagintion: action.data, pageLoader: false};
    // case "PAGE_LOADER":
    //   return { ...state, pageLoader: action.data };
    // case "GET_ALL_EVENTS_LIST_PAGINATED_DATA":
    //   return { ...state, eventListWithPagintion: action.data };
    // case "GET_EVENTS_LIST_DATA":
    //   return { ...state, eventsListData: action.data };
    // case "UPDATE_EVENT":
    //   return { ...state, eventsListData: action.data };
    default:
      return { ...state };
  }
};
export default agendalist;
